import { Box, InputLabel, Typography } from '@mui/material';

import Flex from '@Components/Bases/Flex';
import { OTHER_INCOME_STRUCTURE_ID } from 'src/Enum/IncomeStructure';
import { useIncomeStructure } from '../IncomeStructureProvider/IncomeStructureProvider';
import { findMasterDataById } from '../utils';
import ExportIncomeYearFieldsForm from './ExportIncomeYearFieldsForm';

const ExportIncomeOtherForm = () => {
  const { exportIncome } = useIncomeStructure();

  const otherExportIncome = findMasterDataById(
    exportIncome,
    OTHER_INCOME_STRUCTURE_ID.OTHER_EXPORT_INCOME
  );

  return (
    <>
      {otherExportIncome && (
        <Flex width={1} mt={2} alignItems={'center'}>
          <Box width={1} minWidth={235} maxWidth={350}>
            <InputLabel sx={{ textAlign: 'right' }}>
              {otherExportIncome.nameTh}
            </InputLabel>
            <Typography textAlign={'right'} color={'text.secondary'}>
              (พันบาท)
            </Typography>
          </Box>
          <ExportIncomeYearFieldsForm
            keyItem={otherExportIncome.id.toString()}
          />
        </Flex>
      )}
    </>
  );
};

export default ExportIncomeOtherForm;
